export const timeValues = {
  0: 5,
  10: 10,
  20: 15,
  30: 20,
  40: 30,
};
